function DeleteFolderViewModel() {
    return {};
}

export default DeleteFolderViewModel;
